import { create } from "zustand";

const ContractStore = create((set) => ({
  selectedContract: null,

  setSelectedContract: (issue) =>
    set({ selectedContract: issue }),

  clearSelectedContract: () =>
    set({ selectedContract: null }),
}));

export default ContractStore;